/** @format */
import { useTranslation } from 'next-i18next';

export const useUspSlugToText = (slug: string) => {
    const { t } = useTranslation();
    if (slug === 'low-shutter-count') {
        return t('Great shutter count');
    }
    return '';
};
